import "./user-set-password.scss";
import initPasswordStrengthMeter from "common/jiffy/password-strength-meter";

// Initialize when DOM is loaded or immediately if already loaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPasswordStrengthMeter);
} else {
  initPasswordStrengthMeter();
}
